module.exports = __webpack_public_path__ + "media/images/icons/notes-6904d2f29d56dce866b833ec4f9fd3b5.svg";